<template>
  <div id="simulation" class="form" :class="$mq">
    <h3>{{ $t("simulation.title") }}</h3>
    <div class="relative">
      <transition-group
        name="translate"
        tag="p"
        :class="$mq !== 'mobile' ? 'container inline center top' : ''"
      >
        <div
          class="product"
          v-for="(range, index) in simulationOrdered"
          v-bind:key="range.name"
          :class="[getPosition(index), $mq]"
          @click="showProduct(index)"
        >
          <div class="title">
            <SvgIcon class="icon" :icon="`product-${range.name}`" fill></SvgIcon>
            {{ range.name }}
          </div>

          <div class="price">
            <div class="inline center">
              <span class="amount">{{ range.amounts[annualAmount] | toCurrency }}</span>
              <span>
                {{ $t(`simulation.product.${amountType}`) }}
                <br />
                {{ $t("simulation.product.annualy") }}
              </span>
            </div>
            <div class="inline center">
              <span class="amount second">{{ range.amounts[monthlyAmount] | toCurrency }}</span>
              <span>
                {{ $t(`simulation.product.${amountType}`) }}
                <br />
                {{ $t("simulation.product.monthly") }}
              </span>
            </div>
          </div>

          <button
            class="details"
            @click="showModal(range)"
          >{{ $t('simulation.product.showDetail') }}</button>

          <Services :range="range" :position="getPosition(index)" :key="range.name"></Services>
          <Options
            :range="range"
            @newRange="newRange"
            :key="update"
            v-if="$mq !== 'mobile' || getPosition(index) === 'first'"
          ></Options>

          <div class="become" :class="$mq">
            <a :href="become(range)" class="button">{{ $t('become') }}</a>
          </div>
        </div>
      </transition-group>
    </div>
    <Details :range="modalRange" v-if="showDetails" @close="showDetails = false"></Details>
    <Informations class="information" :class="$mq"></Informations>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Services from "./components/Services";
import Informations from "./components/Informations";
import Options from "./simulation/Options";
import Details from "./simulation/Details";

export default {
  data() {
    return {
      modalRange: null,
      showDetails: false,
      update: 0,
      simulationOrdered: [],
      rangeOptions: {
        wantFix: false,
        wantGreen: false,
        duration: 1
      }
    };
  },
  computed: {
    ...mapState("contact", ["isPro"]),
    ...mapState("simulation", ["elecProducts"]),
    ...mapGetters("podium", ["rangesDesktop", "rangesMobile"]),
    simulation: {
      get() {
        return this.$store.state.simulation.simulation;
      },
      set(value) {
        this.$store.commit("simulation/setSimulation", value);
      }
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    annualAmount() {
      return this.isPro ? "annualAmount" : "annualAmountVAT";
    },
    monthlyAmount() {
      return this.isPro ? "monthlyAmount" : "monthlyAmountVAT";
    },
    podium() {
      return this.$mq === "mobile" ? this.rangesMobile : this.rangesDesktop;
    }
  },
  methods: {
    become(range) {
      return this.$store.getters["middleware/become"](range);
    },
    orderSimulation() {
      // let podium =
      //   this.$mq === "mobile" ? this.rangesMobile : this.rangesDesktop;
      // podium = ['super', 'zen'];

      this.podium.forEach(range => {
        this.simulationOrdered.push(this.simulation[range]);
      });
    },
    showProduct(index) {
      if (this.podium.length > 1) {
        if (this.$mq !== "mobile") {
          if (index === 0) {
            let tmp = this.simulationOrdered[this.simulationOrdered.length - 1];
            this.simulationOrdered.pop();
            this.simulationOrdered.unshift(tmp);
          } else if (index === this.simulationOrdered.length - 1) {
            let tmp = this.simulationOrdered[0];
            this.simulationOrdered.shift();
            this.simulationOrdered.push(tmp);
          }
        } else {
          if (index < 2) {
            let tmp = this.simulationOrdered[2];
            this.simulationOrdered.pop();
            this.simulationOrdered.unshift(tmp);
          }
        }
      }
    },
    getPosition(index) {
      let positions = ["second", "first", "third"];

      if (this.podium.length > 1) {
        positions = ["second", "first", "third"];
        if (this.$mq === "mobile") {
          positions = ["third", "second", "first"];
        }
      } else {
        positions = ["first"];
      }

      return positions[index];
    },
    newRange(newRange) {
      let index = this.simulationOrdered.indexOf(
        this.simulation[newRange.name]
      );
      // Save session?
      this.simulation[newRange.name] = newRange;
      this.simulationOrdered[index] = newRange;
      this.$store.dispatch("simulation/save", this.simulationOrdered);
      this.update++;
    },
    showModal(range) {
      this.modalRange = range;
      this.showDetails = true;
    }
  },
  filters: {
    toCurrency: function(value) {
      return value.toFixed(2).replace(".", ",");
    }
  },
  created() {
    this.$store.dispatch("simulation/save", this.simulationOrdered);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "cookie-acceptation_true",
      "cookie-acceptation": "true"
    });
    window.scrollTo(0, 0);
    this.orderSimulation();
  },
  components: {
    Services,
    Options,
    Details,
    Informations
  }
};
</script>

<style lang="scss" scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
.relative {
  position: relative;
}

.product {
  transition: all 0.6s;
  width: 30%;
  min-width: 250px;
  border-top: 15px solid #fdcb47;
  border-radius: 30px;
  margin-top: 30px;
  background: white;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);

  .details {
    padding: 5px 10px;
    margin-top: 30px;
    border: 0;
    background: none;
    color: #f1911f;
    border: 2px solid #f1911f;
  }

  &.mobile {
    position: absolute;
    width: 100%;
    margin-top: 0;

    &:nth-child(1) {
      top: 0px;
    }

    &:nth-child(2) {
      top: 45px;
    }

    &:nth-child(3) {
      top: 110px;
    }

    &.first {
      position: relative !important;
      // top: 110px;
      z-index: 3;
      border-top: 15px solid #fdcb47;
    }

    &.second {
      z-index: 2;
      // top: 45px;
      width: 96%;
      left: 2%;
    }

    &.third {
      z-index: 1;
      // top: 0px;
      width: 92%;
      left: 4%;
    }
  }

  .title {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 2rem;
    font-weight: 700;

    .icon {
      color: #fdcb47;
      font-size: 3rem;
    }
  }

  .price {
    color: #231f20;
    font-size: 0.6rem;
    padding: 10px 0;

    .amount {
      font-size: 1.8rem;
      font-weight: 500;

      &.second {
        font-size: 1.2rem;
        font-weight: normal;
      }
    }
  }

  .become {
    margin: 30px;

    &.mobile {
      padding-bottom: 30px;
    }

    .button {
      font-weight: 600;
      margin: 0;
      margin-bottom: 20px;
      padding: 10px 20px;
      font-size: 1.3rem;
      border: 0;
      background: #fdcb47;
      border-radius: 50px;
      box-shadow: 3px 6px 8px #fdcb475e;
    }
  }

  &.desktop {
    &.first {
      z-index: 3;
      box-shadow: 1px 0 12px rgba(122, 130, 140, 0.35),
        -1px 0 12px rgba(122, 130, 140, 0.35);
    }

    &.second {
      z-index: 2;
      margin-top: 50px;
    }

    &.third {
      z-index: 1;
      margin-top: 50px;
    }
  }

  &.first {
    .price {
      background: #fdcb47;
    }

    .details {
      color: #fdcb47;
      border: 2px solid #fdcb47;
    }
  }

  &.second,
  &.third {
    border-top: 15px solid #f1911f;

    .title {
      .icon {
        color: #f1911f;
      }
    }

    .price {
      color: white;
      background: #f1911f;
    }
  }

  margin-bottom: 20px;
}
.information.mobile {
  padding-top: 120px;
}
</style>


// WEBPACK FOOTER //
// src/views/Simulation.vue